import React from "react";
import settingsbutton from "../../img/vector-3@2x.svg";
import "./SettingsButton.css";

const SettingsButton = () => {
    return (
        <div className="setting-button">
            <div className="settings-button-2">
                <img className="vector-39" src={settingsbutton} />
                <div className="sidebar-fonts-3">
                    <div className="dashboard-39 nunito-bold-black-14px">Profile</div>
                </div>
            </div>
        </div>
    )
}

export default SettingsButton;